var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href:
            "https://opensaludes.sharepoint.com/:b:/s/General2/EewHuG8R5t1BnvqeB1acUVUBNx-umeNWcdrRgYyuwB2dug?e=tfdM2E",
          target: "_blank"
        }
      },
      [
        _c("img", {
          staticClass: "vertical middle-icon",
          attrs: {
            alt: "ISO 27001 OCA logo",
            src:
              "/static-appopensalud/img/icons/morillas-svg-icons/Logo/27001.png"
          }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28f87180", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28f87180","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/ISO27001Logo.vue
// module id = 2515
// module chunks = 10 16 17 18 19 20 21 22 23 30 31 39 40 50